export default {
  SEARCH_CATALOG_KUSPIT_INCOME_QUERY: Symbol.for('SEARCH_CATALOG_KUSPIT_INCOME_QUERY'),
  CATALOG_KUSPIT_INCOME_REPOSITORY: Symbol.for('CATALOG_KUSPIT_INCOME_REPOSITORY'),
  CATALOG_KUSPIT_INCOME_STATE_MANAGER: Symbol.for('CATALOG_KUSPIT_INCOME_STATE_MANAGER'),
};
